import request from '@/utils/request'

// 分页查询外部应用列表
export function getExternalAppList(params) {
  return request({ url: '/api/external-app/list', method: 'get', params })
}

// 查询应用详情（含 appSecret）
export function getExternalAppDetail(id) {
  return request({ url: `/api/external-app/detail/${id}`, method: 'get' })
}

// 新增
export function addExternalApp(data) {
  return request({ url: '/api/external-app', method: 'post', data })
}

// 编辑
export function updateExternalApp(data) {
  return request({ url: '/api/external-app', method: 'put', data })
}

// 删除
export function deleteExternalApp(id) {
  return request({ url: `/api/external-app/${id}`, method: 'delete' })
}

// 启用/禁用
export function toggleExternalAppStatus(id) {
  return request({ url: `/api/external-app/${id}/toggle-status`, method: 'post' })
}

// 重置密钥
export function resetExternalAppSecret(id) {
  return request({ url: `/api/external-app/${id}/reset-secret`, method: 'post' })
}
